<template>
  <div class="div-class">
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="main">
      <LeftMenu class="left-menu"></LeftMenu>
      <div class="right-menu">
        <div class="right-title-class">
<!--          单据下发-->
          <HeaderTag></HeaderTag>
        </div>
        <el-table
          ref="multipleTable"
          :data="queryDatas"
          tooltip-effect="dark"
          style="width: 100%"
          height="520"
          @selection-change="handleSelectionChange"
          @expand-change="expandSelection"
        >

          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column type="expand" width="40">
            <template slot-scope="props">
              <el-table
                :data="childDatas"
                style="width: 100%">
                <el-table-column
                  prop="RFBILLSN"
                  label="序号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="GOODSNAME"
                  label="商品名称"
                  width="220">
                </el-table-column>
                <el-table-column
                  prop="GOODSSPEC"
                  width="220"
                  label="商品规格">
                </el-table-column>
                <el-table-column
                  prop="UNIT"
                  label="单位">
                </el-table-column>
                <el-table-column
                  prop="PLACE"
                  label="商品产地">
                </el-table-column>
                <el-table-column
                  prop="BATCHCODE"
                  label="批号">
                </el-table-column>
                <el-table-column
                  prop="NUM"
                  label="数量">
                </el-table-column>
                <el-table-column
                  prop="TAXPRICE"
                  label="单价">
                </el-table-column>
                <el-table-column
                  prop="TAXAMOUNT"
                  label="含税金额">
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="BILLNO"
            width="55" >
          </el-table-column>
          <el-table-column
            label="单据编号"
            width="120"
          >
            <template slot-scope="scope">{{ scope.row.BILLCODE }}</template>
          </el-table-column>
          <el-table-column
            prop="RFBILLCODE"
            label="出库单号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="DATES"
            label="日期"
            width="110"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="BUSINESSNAME"
            label="客户名称"
            width="250"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="SALEMANNAME"
            label="业务员"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="TAXAMOUNT"
            label="含税金额"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="ZT"
            label="订单状态"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="DJLX"
            label="单据类型"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>

        <div id="footer">
          <div class="foot_op">
            <div class="btn-area">
              <a class="left-btn" @click.prevent="clearSelection()">清空</a>
            </div>
          </div>
          <div class="foot_total">
            <div class="amout-sum">
              <span class="txt">已选单据</span>
              <strong id="selected_amout">{{totalNum}}</strong>
              <span class="txt">条</span>
            </div>
            <div class="price-sum">
              <span class="txt">合计：{{totalAmount}}</span>
            </div>
            <div class="btn-area">
              <a class="btn-sumbit" :class="{'btn-allow': totalAmount} " @click.prevent="submitData()" >确定</a>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Navigation from "../component/Navigation";
import LogoHome from "../component/LogoHome";
import LeftMenu from "../component/LeftMenu";
import HeaderTag from "../component/HeaderTag"
import {billOrders, getBillNo,saveBill} from '../../api';
export default {
  components:{
    ShortCut,
    Navigation,
    LogoHome,
    LeftMenu,
    HeaderTag
  },
  data(){
    return{
      queryDatas:[],
      userInfo:{},
      totalNum:0,
      totalAmount:0,
      childDatas:[],
      BILLNO:0,
      BILLCODE:""
    }
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection)
      // console.log(this.$refs.multipleTable.toggleRowSelection(row));
      // let rows = this.queryDatas;
      // if (rows) {
      //   rows.forEach(row => {
      //     this.$refs.multipleTable.toggleRowSelection(row);
      //   });
      // }
      this.lineCalculation();
    },
    queryBill(){
      this.queryDatas = [];
        billOrders({
          M_STAFFID: this.userInfo.STAFFID,
          M_ORGID: this.userInfo.OWNERID,
          M_ENTID: this.userInfo.ENTID,
          M_ACTION: 91,
          M_PAGECOUNT: 1000,
          M_PAGE: 1

        }).then(res => {
          // console.log(res);
          //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
          // 请求返回数据
          let dataset = res.data.data.DATASET;
          // console.log("dataset" + dataset);
          if (dataset.length == 0) {
            this.$message.error('当前未存在合单单据');
            return false;
          } else {
            //this.options=dataset;
            this.queryDatas = dataset;
            // console.log(dataset[0]);
            // sessionStorage.setItem("USERINFO",dataset[0]);
            // this.$router.push('/home');
          }
        }).catch(err => {
          // 请求失败执行
          // console.log(err)
        })

    },

    initForm(){
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));

    },
    clearSelection(){
      this.$refs.multipleTable.clearSelection();
    },
    lineCalculation(){
      this.totalNum = 0;
      this.totalAmount = 0;
      let tables = this.$refs.multipleTable.selection;
      if (tables) {
        tables.forEach(row => {
          console.log(row);
          this.totalNum = this.totalNum+1;
          this.totalAmount = this.totalAmount+row.TAXAMOUNT;
        });
      }
    },
    expandSelection(row, expandedRows){
      if (expandedRows.length > 0) {

        this.childDatas = [];
        billOrders({
          M_STAFFID: this.userInfo.STAFFID,
          M_ORGID: this.userInfo.OWNERID,
          M_ENTID: this.userInfo.ENTID,
          M_ACTION: 82,
          M_PAGECOUNT: 1000,
          M_PAGE: 1,
          M_BILLNO: row.BILLNO,
        }).then(res => {
          // console.log(res);
          //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
          // 请求返回数据
          let dataset = res.data.data.DATASET;
          // console.log("dataset" + dataset);
          if (dataset.length == 0) {
            this.$message.error('当前未存在合单单据');
            return false;
          } else {
            //this.options=dataset;
            this.childDatas = dataset;
            // console.log(dataset[0]);
            // sessionStorage.setItem("USERINFO",dataset[0]);
            // this.$router.push('/home');
          }
        }).catch(err => {
          // 请求失败执行
          // console.log(err)
        })

        // console.log(row);
        // rule
        //   .itemSelectByRuleID({
        //     examruleid: row.id
        //   })
        //   .then(res => {
        //     // 遍历当前页面表
        //     this.tableData.forEach((temp, index) => {
        //       // 找到当前点击的行，把动态获取到的数据赋值进去
        //       if (temp.id === row.id) {
        //         this.tableData[index].ruleItemData = res.content;
        //       }
        //     });
        //   });
      }
    },
    submitData(){
      // let dates = new Date();
      // let year = dates.getFullYear();
      // let month = dates.getMonth()+1<10 ? "0"+ dates.getMonth()+1 : dates.getMonth()+1;
      // let date = dates.getDate()<10 ? "0"+ dates.getDate() : dates.getDate();
      // let hours = dates.getHours()<10 ? "0"+ dates.getHours() : dates.getHours();
      // let minutes = dates.getMinutes()<10 ? "0"+ dates.getMinutes() : dates.getMinutes();
      // let seconds = dates.getSeconds()<10 ? "0"+ dates.getSeconds() : dates.getSeconds();
      // let onDates = year + "-" + month + "-" +date;
      // let onTimes = hours+":"+minutes+":"+seconds;
      // this.BILLCODE = "XHDN"+year+""+month+""+date+""+hours+""+minutes+""+seconds;

      let dates = new Date();
      let year = dates.getFullYear();
      let month = dates.getMonth()+1<10 ? "0"+ Math.round(dates.getMonth()+1) : dates.getMonth()+1;
      let date = dates.getDate()<10 ? "0"+ Math.round(dates.getDate()) : dates.getDate();
      let hours = dates.getHours()<10 ? "0"+ dates.getHours() : dates.getHours();
      let minutes = dates.getMinutes()<10 ? "0"+ dates.getMinutes() : dates.getMinutes();
      let seconds = dates.getSeconds()<10 ? "0"+ dates.getSeconds() : dates.getSeconds();
      let onDates = year + "-" + month + "-" +date;
      let onTimes = hours+":"+minutes+":"+seconds;
      year = year.toString().substring(2,2);
      this.BILLCODE = "XHDN"+year+""+month+""+date+""+hours+""+minutes+""+seconds;

      this.getBillNo();

      let tables = this.$refs.multipleTable.selection;
      if (tables) {
        tables.forEach(row => {
          billOrders({
            M_STAFFID: this.userInfo.STAFFID,
            M_ORGID: this.userInfo.OWNERID,
            M_ENTID: this.userInfo.ENTID,
            M_ACTION: 92,
            M_PAGECOUNT: 1000,
            M_PAGE: 1,
            M_BILLNO: row.BILLNO,
            M_HDBILLCODE: this.BILLCODE,
            M_HDBILLNO: this.BILLNO,
          }).then(res => {
            // console.log(res);
            //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
            // 请求返回数据
            let dataset = res.data.data.DATASET;
            if(typeof dataset == "undefined"){
              this.$message.error(res.data.data.result);
              return false;
            }

            // console.log("dataset" + dataset);
            if (dataset.length == 0) {
              this.$message.error('当前未存在合单单据');
              return false;
            } else {
              //this.options=dataset;

              // console.log(dataset[0]);
              // sessionStorage.setItem("USERINFO",dataset[0]);
              // this.$router.push('/home');
            }
          }).catch(err => {
            // 请求失败执行
            // console.log(err)
          })
        });
        this.queryBill();
      }
    },

    getBillNo(){
      getBillNo({
      }).then(res => {
        this.BILLNO = res.data.data.BillNo;
        console.log(this.BILLNO);
      }).catch(err => {
        this.$message.error('获取单号失败，请重新打开页面！');
        return false;
      })
    },
    headerInit(){
      let tag = [];
      if(sessionStorage.getItem("TAG") ==null || sessionStorage.getItem("TAG")==""){

      }else{
        tag=JSON.parse(sessionStorage.getItem("TAG"));
      }
      console.log(tag);
      let tagChild = {};
      tagChild.type = "";
      tagChild.name = "单据下发";
      tagChild.url = "/members"
      let tagFlag = false;
      for(var j=0;j<tag.length;j++){
        if(JSON.stringify(tag[j])==JSON.stringify(tagChild)){
          tagFlag = true;
        }
      }
      if(!tagFlag){
        tag.push(tagChild);
      }
      sessionStorage.setItem("TAG",JSON.stringify(tag));
    }
  },
  mounted(){
    this.initForm();
    this.queryBill();
    // let tag = JSON.stringify(sessionStorage.getItem("TAG")) == null || sessionStorage.getItem("TAG") == undefined ? [] : sessionStorage.getItem("TAG");

    this.headerInit();
  }
}
</script>

<style scoped>
.nav_item{
  height:45px;
  line-height:45px;
  color:white;
  list-style-type:none
}
.main{
  height: 100%;
  display: flex;
}
.div-class{
  height: 100%;
  width: 100%;
  position:fixed;
}

.right-menu{
  padding-left: 5px;
  width: 70%;
}

.right-title-class{
  height: 45px;
  text-align: left;
  line-height: 45px;
  background-color: #f1f1f1;
  padding-left: 10px;
  font-size: 20px;
}

#footer{
  width: 70%;
  height: 50px;
  position: fixed;
  bottom: 0;
  /*padding-left: 10px;*/
  background: #E5E5E5;
  z-index: 9999;
}
#footer div{
  display: inline-block;
}
#footer>.foot_select{
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding-left: 5px;
  cursor: pointer;
  font-size: 14px;
}
.foot_select input,.foot_select label{
  cursor: pointer;
}
.foot_op{
  float: left;
  line-height: 50px;
  height: 50px;
}
.foot_op>.foot_remove{
  margin-left: 0px;
  font-size: 14px;
  cursor: pointer;
}
.foot_remove:hover{
  color: #f40;
}
.foot_total{
  float: right;
}
.foot_total>.amout-sum{
  cursor: pointer;
  height: 50px;
  color: #3c3c3c;
}
.foot_total .txt{
  line-height: 50px;
  font-size: 14px;
}
.btn-area>.btn-sumbit{
  display: inline-block;
  background: #B0B0B0;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  cursor: not-allowed;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
.btn-area>.btn-sumbit.btn-allow{
  background: #f22d00;
  cursor: pointer;
}
.left-btn{
  background: #387af6;
  cursor: pointer;
  display: inline-block;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}

.amout-sum>#selected_amout{
  padding: 0 5px;
  color: #f40;
  font-weight: 700;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Members.vue